import React from "react";

import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  GridItem,
  Heading,
  Input,
  Select,
  SimpleGrid,
  Stack,
  VStack,
} from "@chakra-ui/react";
import InputMask from "react-input-mask";
import LeadFormWrapper from "src/components/forms/LeadFormWrapper/LeadFormWrapper";

import { ILeadFormWrapperProps } from "src/components/forms/LeadFormWrapper/LeadFormWrapper";

import { IFormGetUserResponse } from "@pages/api/lead-form-getuser";
import axios from "axios";
import { useRouter } from "next/router";
import { useState } from "react";
import {
  IFlexDisplay,
  IMainContactFormFields,
} from "src/types/generated/contentful";
import { BlockRenderer } from "../../molecules/BlockRenderer";

interface IMainContactFormProps
  extends Omit<IMainContactFormFields, "successMessage"> {
  defaultContent?: React.ReactElement | undefined;

  confirmationMessage?: React.ReactElement;
  submitButtonTitle?: string;
  successMessage?: IFlexDisplay | React.ReactElement;
  verificationMessage?: string;
}
export default function LeadForm(data: IMainContactFormProps) {
  //console.log("LeadForm", data);
  const {
    title,
    content: formTopContent,
    defaultContent,
    beforeSubmitContent,
    formBottomContent,
    successMessage,
    verificationMessage,
    submitButtonTitle,
  } = data;

  const [referrerId, setReferrerId] = useState<string | string[]>();
  const [refereeId, setRefereeId] = useState<string | string[]>();
  const [refereeEmail, setRefereeEmail] = useState<string | string[]>();
  const [firstName, setFirstName] = useState<string | string[]>();
  const [lastName, setLastName] = useState<string | string[]>();
  const [beforeSubmitContentBlock, setBeforeSubmitContentBlock] =
    useState<any>();
  const [formBottomContentBlock, setFormBottomContentBlock] = useState<any>();
  const [formTopContentBlock, setFormTopContentBlock] = useState<any>();

  const { query } = useRouter();

  React.useEffect(() => {
    if (query.referrerid && query.refereeid) {
      setReferrerId(query.referrerid);

      const refereeData = axios
        .get(`/api/lead-form-getuser?uuid=${query?.refereeid?.toString()}`)
        .then((res: any) => {
          const data = res?.data as IFormGetUserResponse;
          setFirstName(data?.user?.firstname);
          setLastName(data?.user?.lastname);
          setRefereeEmail(data?.user?.email);
        });
      setRefereeId(query.refereeid);
    }
  }, [query.referrerid, query.refereeid]);

  React.useEffect(() => {
    if (formTopContent) {
      setFormTopContentBlock(
        <BlockRenderer
          block={formTopContent}
          layoutId="customContactForm"
          key="customContactForm"
        />
      );
    }
  }, [formTopContent]);

  React.useEffect(() => {
    if (formBottomContent) {
      const fm = formBottomContent ? (
        <Box mt={4}>
          <BlockRenderer
            block={formBottomContent}
            layoutId="formBottomContent"
            key="formBottomContent"
          />
        </Box>
      ) : null;
      setFormBottomContentBlock(fm);
    }
  }, [formBottomContent]);

  React.useEffect(() => {
    // save the query to pass to the lead form later only if there is no query in local storage
    const test = localStorage.getItem("query") as any;
    if (
      !(
        test?.utm_source ||
        test?.utm_medium ||
        test?.utm_campaign ||
        test?.utm_term
      ) &&
      (query?.utm_source ||
        query?.utm_medium ||
        query?.utm_campaign ||
        query?.utm_term)
    ) {
      localStorage.setItem("query", JSON.stringify(query));
    }
  }, [query]);

  React.useEffect(() => {
    if (beforeSubmitContent) {
      setBeforeSubmitContentBlock(
        <BlockRenderer
          block={beforeSubmitContent}
          layoutId="beforeSubmitContent"
          key="beforeSubmitContent"
        />
      );
    }
  }, [beforeSubmitContent]);

  const successMessageBlock = !successMessage ? (
    <Flex direction="column" alignItems="center" p={8} maxW={900}>
      <Heading as="h2" textAlign="center">
        Thank You
      </Heading>

      <Box textAlign="center">
        We have everything we need to get started finding you the best Medicare
        plan to fit your needs. A Licensed Sales Agent will be contacting you
        soon.
      </Box>
    </Flex>
  ) : (
    <Flex direction="column" alignItems="center" p={8} maxW={900}>
      <Box textAlign="center">
        <BlockRenderer block={successMessage} layoutId="successMessage" />
      </Box>
    </Flex>
  );

  const formDefaultHeader = defaultContent ?? (
    <Flex direction="column" alignItems="center" p={8} maxW={900}>
      <Heading as="h2" textAlign="center" size="4xl">
        {"Ready to Get Started?"}
      </Heading>

      <Box textAlign="center" w={["100%", "75%", "50%"]}>
        Get FREE Medicare help today! Please enter your information and a
        licensed agent will contact you.
      </Box>
    </Flex>
  );
  return (
    <LeadFormWrapper
      data={{
        refereeEmail,
        referrerId,
        firstName,
        lastName,
      }}
      id="LeadForm"
    >
      {({ formik, submitted }: ILeadFormWrapperProps): JSX.Element => (
        <Center id="Center">
          <Stack id="getStartedNow" alignItems={"center"}>
            {submitted ? (
              successMessageBlock
            ) : (
              <>
                {formTopContent ? (
                  formTopContentBlock
                ) : (
                  <>{formDefaultHeader}</>
                )}
                <Stack maxW={500} spacing={6} p={5}>
                  {/*
            <label htmlFor="email">Email</label>
            <FormField name="email" placeholder="Enter Your Email" />
            */}
                  {formik?.errors?.email}
                  <FormControl
                    variant="floating"
                    id="email"
                    isRequired
                    onBlur={formik?.handleBlur}
                    onChange={formik?.handleChange}
                    isInvalid={Boolean(
                      formik?.touched?.email && formik?.errors?.email
                    )}
                    style={{ display: referrerId ? "none" : "block" }}
                  >
                    <Input
                      placeholder=" "
                      type="email"
                      id="email"
                      size="lg"
                      onChange={formik?.handleChange}
                      value={refereeEmail || formik?.values?.email}
                    />
                    <FormLabel htmlFor="email">Email</FormLabel>
                    <FormErrorMessage fontWeight="semibold" color="red.600">
                      {formik?.errors?.email ||
                        `Please enter a valid email address.`}
                    </FormErrorMessage>
                  </FormControl>
                  <SimpleGrid minChildWidth="150px" gap={6}>
                    <GridItem colSpan={1}>
                      <FormControl
                        variant="floating"
                        id="firstName"
                        isRequired
                        isInvalid={Boolean(
                          formik?.touched?.firstName &&
                            formik?.errors?.firstName
                        )}
                      >
                        <Input
                          placeholder=" "
                          id="firstName"
                          type="text"
                          size="lg"
                          onBlur={formik?.handleBlur}
                          onChange={formik?.handleChange}
                          value={formik?.values?.firstName || firstName}
                        />
                        <FormLabel htmlFor="firstName">First Name</FormLabel>
                        <FormErrorMessage fontWeight="semibold" color="red.600">
                          Please enter your first name.
                        </FormErrorMessage>
                      </FormControl>
                    </GridItem>
                    <GridItem colSpan={1}>
                      <FormControl
                        variant="floating"
                        id="lastName"
                        isRequired
                        isInvalid={Boolean(
                          formik?.touched?.lastName && formik?.errors?.lastName
                        )}
                      >
                        <Input
                          placeholder=" "
                          id="lastName"
                          type="text"
                          size="lg"
                          onBlur={formik?.handleBlur}
                          onChange={formik?.handleChange}
                          value={formik?.values?.lastName || lastName}
                        />
                        <FormLabel htmlFor="lastName">Last Name</FormLabel>
                        <FormErrorMessage fontWeight="semibold" color="red.600">
                          Please enter your last name.
                        </FormErrorMessage>
                      </FormControl>
                    </GridItem>
                    {referrerId ? (
                      <input
                        hidden={true}
                        name="referrerId"
                        value={referrerId}
                      />
                    ) : null}
                  </SimpleGrid>
                  {/*<label htmlFor="zip">Email</label>
            <FormField name="zip" placeholder="Zip Code" />*/}
                  {/*
                                <label htmlFor="firstName">Name</label>
<FormFieldRow>
              <FormField name="firstName" placeholder="First Name" />
              <FormField name="lastName" placeholder="Last Name" />
          </FormFieldRow>*/}
                  <SimpleGrid minChildWidth="150px" gap={6}>
                    <GridItem colSpan={1}>
                      <FormControl
                        variant="floating"
                        id="phone"
                        isRequired
                        isInvalid={Boolean(
                          formik?.touched?.phone && formik?.errors?.phone
                        )}
                      >
                        <Input
                          placeholder=" "
                          // @ts-ignore
                          as={InputMask}
                          id="phone"
                          mask="(***) ***-****"
                          //maskChar={null}
                          type="tel"
                          size="lg"
                          onBlur={formik?.handleBlur}
                          onChange={formik?.handleChange}
                          value={formik?.values?.phone}
                        />
                        <FormLabel htmlFor="phone">Phone Number</FormLabel>
                        <FormErrorMessage fontWeight="semibold" color="red.600">
                          Please enter a valid phone number.
                        </FormErrorMessage>
                      </FormControl>
                    </GridItem>
                    {/*<label htmlFor="phone">Phone Number</label>
            <FormField
              componentType="textmask"
              name="phone"
              controlProps={{
                mask: "(999) 999-9999",
              }}
              placeholder="Phone Number"
            />*/}
                    {/*<label htmlFor="zip">Email</label>
            <FormField name="zip" placeholder="Zip Code" />*/}
                    <GridItem colSpan={1}>
                      <FormControl
                        variant="floating"
                        id="zip"
                        isRequired
                        isInvalid={Boolean(
                          formik?.touched?.zip && formik?.errors?.zip
                        )}
                      >
                        <Input
                          placeholder=" "
                          size="lg"
                          // @ts-ignore
                          as={InputMask}
                          mask="*****"
                          onBlur={formik?.handleBlur}
                          onChange={formik?.handleChange}
                          value={formik?.values?.zip}
                        />
                        <FormLabel htmlFor="zip">Zip</FormLabel>
                        <FormErrorMessage fontWeight="semibold" color="red.600">
                          Please enter a valid zip code.
                        </FormErrorMessage>
                      </FormControl>
                    </GridItem>
                  </SimpleGrid>
                  {referrerId ? (
                    <FormControl
                      variant="floating"
                      id="product_family"
                      isRequired
                      isInvalid={Boolean(
                        formik?.touched?.phone && formik?.errors?.phone
                      )}
                    >
                      <Select
                        id="product_family"
                        name="product_family"
                        onBlur={formik?.handleBlur}
                        onChange={formik?.handleChange}
                        placeholder="Please select a product you're interested in"
                      >
                        <option value="MA">Medicare Advantage</option>
                        <option value="MS">Medicare Supplement</option>
                        <option value="other">Other</option>
                      </Select>
                      <FormLabel>Product Interest</FormLabel>
                    </FormControl>
                  ) : null}
                  {formik?.status ? (
                    <Alert status="error" borderRadius={10}>
                      <AlertIcon />
                      There was an error processing your request
                    </Alert>
                  ) : null}
                  <Center w="100%">
                    <VStack w="100%">
                      <Checkbox
                        id="verification"
                        name="verification"
                        onBlur={formik?.handleBlur}
                        onChange={formik?.handleChange}
                        isChecked={formik?.values?.verification}
                        isInvalid={Boolean(
                          formik?.touched?.verification &&
                            formik?.errors?.verification
                        )}
                        gap={1}
                        mt={2}
                      >
                        {verificationMessage ||
                          "I verify that the contact information entered is correct and is my personal information and that I am over 18 years of age."}
                      </Checkbox>
                      <Box mt={4}>{beforeSubmitContentBlock}</Box>
                      <Button
                        type="submit"
                        variant={"brand-solid-accent"}
                        cursor="pointer"
                        disabled={formik?.isSubmitting}
                        isLoading={formik?.isSubmitting}
                        loadingText="Submitting"
                      >
                        {submitButtonTitle || "Get me started"}
                      </Button>

                      {formBottomContentBlock}
                    </VStack>
                  </Center>
                </Stack>
              </>
            )}
          </Stack>
        </Center>
      )}
    </LeadFormWrapper>
  );
}
